module.exports = __webpack_public_path__ + "static/media/PHEV.b24d6650.svg";